module.exports = __webpack_public_path__ + "img/academy_popup_3.b83afe32.svg";